import React from 'react';
type Brand = {
  name: string;
  src?: string;
  wordmark?: 'aspen' | 'multi-radiance' | 'lumanova' | 'brand';
};
const BRANDS: Brand[] = [{
  name: 'Aspen Laser',
  wordmark: 'aspen'
}, {
  name: 'Multi Radiance Medical',
  wordmark: 'multi-radiance'
}, {
  name: 'LumaNova',
  wordmark: 'lumanova'
}, {
  name: 'TheraLight',
  src: 'https://cdn.magicpatterns.com/uploads/vttP1Sb7gikoGaFWY35ZNt/theralight-logo-tight.png'
}, {
  name: 'WellVu',
  src: 'https://cdn.magicpatterns.com/uploads/qMimGwm5vM6HRxKcW7oosi/wellvu-logo.png'
}, {
  name: 'RegenOMedix',
  src: 'https://cdn.magicpatterns.com/uploads/kjFX5H2HTkPc53njVnmw7m/regenomedix-logo.png'
}, {
  name: 'PainWave',
  src: 'https://cdn.magicpatterns.com/uploads/tEGMAXAr51egcgWdJp6WFL/painwave-logo.png'
}, {
  name: 'CTN-USA',
  src: 'https://cdn.magicpatterns.com/uploads/1hhfWhvefeDvCfWaqe9ZMJ/ctn-usa-logo.png'
}, {
  name: 'Invisa-RED',
  src: 'https://cdn.magicpatterns.com/uploads/iGeardWcM8A5hHzBqR2jS6/invisa-red-logo.png'
}, {
  name: 'HydroWave',
  src: 'https://cdn.magicpatterns.com/uploads/vwTK5cExYRc6dcQX67vs1W/hydrowave-logo.png'
}, {
  name: 'Summus',
  src: 'https://cdn.magicpatterns.com/uploads/pd7fH26BN3F6wMJQurtyqN/summus-logo.png'
}, {
  name: 'NeuroReformer',
  src: 'https://cdn.magicpatterns.com/uploads/cr2fRFUb942Q6xKwFVyH4e/neuroreformer-logo.png'
}, {
  name: 'Team Medical Group',
  src: 'https://cdn.magicpatterns.com/uploads/9nXJ6g9P32g5r6G7ZpCTk8/team-medical-group-logo.png'
}, {
  name: 'Visnova',
  wordmark: 'brand'
}];
function BrandMark({
  brand
}: {
  brand: Brand;
}) {
  if (brand.src) {
    return <img src={brand.src} alt={`${brand.name} logo`} className="manufacturer-strip__logo block h-auto max-h-8 w-full max-w-[124px] object-contain" data-id="element-423" data-mp="3bwsyg17qyasx" />;
  }
  switch (brand.wordmark) {
    case 'aspen':
      return <span className="flex w-full max-w-full flex-col items-center justify-center px-2 text-center leading-none" data-id="element-424" data-mp="3lvi6z3dr6iwi">
          <span className="text-[14px] font-extrabold tracking-[0.02em] text-teal" data-id="element-425" data-mp="2w4ry659dtuwl">ASPEN</span>
          <span className="mt-1 text-[10px] font-semibold tracking-[0.08em] text-navy/75" data-id="element-426" data-mp="2r5x7kh56b21x">LASER</span>
        </span>;
    case 'multi-radiance':
      return <span className="flex items-center gap-1.5 whitespace-nowrap text-navy" data-id="element-427" data-mp="315foeopse7pr">
          <span className="flex h-4 w-4 items-center justify-center rounded-full border border-teal/60" data-id="element-428" data-mp="3ewt4fsohkng1">
            <span className="h-1.5 w-1.5 rounded-full bg-teal" data-id="element-429" data-mp="39xhm4f8h19wc" />
          </span>
          <span className="flex flex-col leading-none" data-id="element-430" data-mp="3owbm22gxbx4x">
            <span className="text-[12px] font-bold tracking-[-0.04em]" data-id="element-431" data-mp="3otpei2u19hmp">Multi Radiance</span>
            <span className="mt-0.5 text-[7px] font-semibold uppercase tracking-[0.14em] text-teal" data-id="element-432" data-mp="3jxgr625omi4g">
              Medical
            </span>
          </span>
        </span>;
    case 'lumanova':
      return <span className="flex items-center gap-1.5 whitespace-nowrap text-navy" data-id="element-433" data-mp="1pl0spnj4o8a5">
          <span className="h-3 w-3 rounded-full border-[3px] border-teal" data-id="element-434" data-mp="51f2nm8w4ud4" />
          <span className="text-[17px] font-bold tracking-[-0.05em]" data-id="element-435" data-mp="9yf0xazi0sto">LumaNova</span>
        </span>;
    case 'brand':
      return <span className="max-w-full px-1 text-center text-[12px] font-bold leading-tight tracking-[-0.02em] text-navy sm:text-[13px]" data-id="element-436" data-mp="3redmvufgqsm9">
          {brand.name}
        </span>;
    default:
      return null;
  }
}
export function ManufacturerStrip() {
  return <section className="manufacturer-strip w-full max-w-full overflow-x-hidden border-y border-slate-200 bg-slate-50/90" data-id="element-437" data-mp="3mhws4hdrdg07">
      <div className="manufacturer-strip__inner mx-auto w-full max-w-7xl box-border overflow-x-hidden px-5 py-7 sm:px-8" data-id="element-438" data-mp="38jgk8n45tjgh">
        <p className="manufacturer-strip__heading mx-auto max-w-full whitespace-normal break-words px-2 text-center text-[11px] font-semibold uppercase leading-snug tracking-[0.16em] text-charcoal/55" data-id="element-439" data-mp="16pzc7ic4agl7">
          <span className="manufacturer-strip__heading-mobile" data-id="element-440" data-mp="37ryl9wlgkfdr">Our Partners</span>
          <span className="manufacturer-strip__heading-desktop" data-id="element-441" data-mp="37puhrfrh1ie0">Our Partners</span>
        </p>
        <ul className="manufacturer-strip__chips mx-auto mt-4 grid w-full max-w-[300px] grid-cols-1 gap-2.5 sm:max-w-7xl sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-9 lg:gap-2" aria-label="Trusted modality brands" data-id="element-442" data-mp="32r17rxbe89il">
          {BRANDS.map(brand => <li key={brand.name} className={`flex h-14 min-w-0 w-full items-center justify-center rounded-xl border border-slate-200 bg-white px-3 shadow-[0_3px_10px_-7px_rgba(26,27,75,0.34)] ${brand.wordmark === 'aspen' ? 'overflow-visible' : 'overflow-hidden'}`} data-id="element-443" data-mp="2ounmse7nhpzd">
              <BrandMark brand={brand} data-id="element-444" data-mp="2azuzgtlir5i8" />
            </li>)}
        </ul>
      </div>
    </section>;
}